import { useContext } from "react";
import { Trans } from "react-i18next";
import { JointBillContext } from "@features/JointBillList/utils";
import { formatPrice } from "@utils/units";

interface IMobileTotalsProps {
  paidAmount?: number;
  unpaidAmount?: number;
}

export const MobileTotals: React.FC<IMobileTotalsProps> = ({
  paidAmount = 0,
  unpaidAmount = 0,
}) => {
  const { isArchiveMode } = useContext(JointBillContext);

  return (
    <div className="flex flex-col gap-1.5 whitespace-nowrap text-sm text-base-black md:hidden">
      <span className="flex justify-between">
        <Trans
          i18nKey="bill.totalPaid"
          values={{
            amount: formatPrice(paidAmount),
          }}
          components={{
            b: <span className="font-semibold" />,
          }}
        />
      </span>
      <span className="flex justify-between">
        <Trans
          i18nKey={isArchiveMode ? "bill.remainingAmount" : "bill.leftToPay"}
          values={{
            amount: formatPrice(unpaidAmount),
          }}
          components={{
            b: <span className="font-semibold" />,
          }}
        />
      </span>
    </div>
  );
};
